export default "__VITE_ASSET__CUVziHVA__"